export default function () {
  const widgetName = 'cardWidgetQuickLink';
  const widgetOpts = cardWidgetQuickLinkOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
      } else {
        $(`#${widgetName}`).show();
        removeUnusedTags({ widgetName });
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['title'],
    maxItemsVisible: 2,
    moreButton: {
      visible: false,
    },
    scriptPath: widgetOpts.scriptPath,
    textOverImage: false,
  });
}

// remove buttonwrap if empty
function removeUnusedTags({ widgetName }) {
  $(`#${widgetName}`).find('.buttonwrap').remove();
}
